module.exports = __webpack_public_path__ + "static/media/datasheet_listData_row9_certificate.c47bb09e.png";